export const SET_ORGANISATION_FUNDS = 'fund/SET_ORGANISATION_FUNDS';
export const SET_SELECTED_FUND = 'fund/SET_SELECTED_FUND';
export const SET_ORGANISATION_PENSION_SCHEMES =
  'fund/SET_ORGANISATION_PENSION_SCHEMES';
export const SET_STRATEGIES = 'fund/SET_STRATEGIES';
export const SET_PRODUCT_TYPES = 'fund/SET_PRODUCT_TYPES';
export const SET_FUNDS_PAGINATION_META = 'fund/SET_FUNDS_PAGINATION_META';

export const SET_ORGANISATION_EXPOSED_FUNDS =
  'fund/SET_ORGANISATION_EXPOSED_FUNDS';
export const SET_EXPOSED_FUNDS_PAGINATION_META =
  'fund/SET_EXPOSED_FUNDS_PAGINATION_META';
export const SET_ORGANIZATION_SUB_FUNDS = 'fund/SET_ORGANIZATION_SUB_FUNDS';
export const SET_ORGANIZATION_MANAGERS = 'fund/SET_ORGANIZATION_MANAGERS';
export const SET_EXPOSED_FUNDS_FILTERS = 'fund/SET_EXPOSED_FUNDS_FILTERS';
export const SET_ALL_FUNDS_FILTERS = 'fund/SET_ALL_FUNDS_FILTERS';
